import React from 'react'
import { useQuery } from 'react-query'
import { Grid, makeStyles } from '@material-ui/core'
import dashboardStyles from './dashboard.styles'
import QueryKeys from '../../../utils/constants/queryKeys'
import LoaderDots from '../../../components/loaders/LoaderDots/LoaderDots'
import getOrgs from '../../../Apis/organisation/getOrgs'
import ConditionalRender from '../../../components/ConditionalRender/ConditionalRender'
import NoOrgLanding from './NoOrgLanding/NoOrgLanding'

const Dashboard = () => {
  const useStyles = makeStyles(dashboardStyles)
  const classes = useStyles()

  const allOrgs = useQuery([QueryKeys.GET_ORGS], () => getOrgs())

  return (
    <div className={classes.wrapper}>
      <ConditionalRender renderValue={allOrgs.isFetching}>
        <Grid container justifyContent='center' alignItems='center'>
          <LoaderDots className={dashboardStyles.loader} />
        </Grid>
      </ConditionalRender>

      <ConditionalRender renderValue={!allOrgs.isFetching && allOrgs.data?.length == 0}>
        <NoOrgLanding />
      </ConditionalRender>
    </div>
  )
}

export default Dashboard
